<!-- search bar -->
<!-- <app-keyword-search></app-keyword-search> -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex align-items-center">
            <img [src]="partner?.logo ?? 'src-ironside/assets/images/image-default.jpg'" alt="" />
            <h2>{{ partner?.companyName }}</h2>
        </div>
        <div class="contact-details d-flex justify-content-between">
            <div class="contact-rgt col-3">
                <p *ngIf="partner?.code">
                    <strong>{{ 'IRONSIDE.partners-detail.CODE' | translate }}:</strong
                    >{{ partner?.code }}
                </p>
                <p *ngIf="partner?.siret">
                    <strong>{{ 'IRONSIDE.partners-detail.SIRET' | translate }}:</strong
                    >{{ partner?.siret }}
                </p>
                <p *ngIf="partner?.vat" class="m-0">
                    <strong>{{ 'IRONSIDE.partners-detail.VAT' | translate }}:</strong
                    >{{ partner?.vat }}
                </p>
            </div>
            <div class="contact-lft col-9">
                <h3>{{ 'IRONSIDE.partners-detail.CONTACT_DETAILS' | translate }}</h3>
                <div class="contact-for d-flex justify-content-between gap-2">
                    <div *ngIf="partner?.phone">
                        <strong>{{ 'IRONSIDE.partners-detail.PHONE' | translate }}:</strong>
                        <a *ngIf="partner?.phone" [href]="'tel:' + partner?.phone">{{
                            partner?.phone
                        }}</a>
                    </div>
                    <div *ngIf="partner?.email">
                        <strong>{{ 'IRONSIDE.partners-detail.EMAIL' | translate }}:</strong>
                        <a *ngIf="partner?.email" [href]="'mailto' + partner?.email">{{
                            partner?.email
                        }}</a>
                    </div>
                    <div *ngIf="partner?.website">
                        <strong>{{ 'IRONSIDE.partners-detail.WEBSITE' | translate }}:</strong>
                        <a *ngIf="partner?.website" [href]="partner?.website">{{
                            partner?.website
                        }}</a>
                    </div>
                    <div *ngIf="partner?.address">
                        <strong>{{ 'IRONSIDE.partners-detail.ADDRESS' | translate }}:</strong>
                        <span>{{ partner?.address }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="contact" *ngIf="contacts">
    <div class="container">
        <h2>{{ 'IRONSIDE.partners-detail.CONTACTS' | translate }}</h2>
        <div class="table-product">
            <p-table [value]="contacts">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{ 'IRONSIDE.partners-detail.JOB' | translate }}</th>
                        <th>{{ 'IRONSIDE.partners-detail.LAST_NAME' | translate }}</th>
                        <th>{{ 'IRONSIDE.partners-detail.FIRST_NAME' | translate }}</th>
                        <th>{{ 'IRONSIDE.partners-detail.PHONE' | translate }}</th>
                        <th>{{ 'IRONSIDE.partners-detail.EMAIL' | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            <strong>{{ item?.job }}</strong>
                        </td>
                        <td>{{ item?.lastName }}</td>
                        <td>{{ item?.firstName }}</td>
                        <td>
                            <a *ngIf="item?.phone" [href]="'tel:' + item?.phone">{{
                                item?.phone
                            }}</a>
                        </td>
                        <td>
                            <a *ngIf="item?.email" [href]="'mailto:' + item?.email">{{
                                item?.email
                            }}</a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
